export const aciCheckIn = {
    iconName: 'check-in',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: [
            {
                attr: {
                    d: 'M13.2 13.8a4.8 4.8 0 00-4.8-4.2 4.8 4.8 0 00-4.818 4.371M11.1 5.7a2.7 2.7 0 01-5.4 0V3.6a.6.6 0 01.6-.6h4.2a.6.6 0 01.6.6v2.1z',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M21 21H3v-6a1.2 1.2 0 011.2-1.2h15.6A1.2 1.2 0 0121 15v6zM5.705 5.846c.867-.3 1.778-.45 2.695-.446a8.134 8.134 0 012.7.448',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M14.4 13.8a3.004 3.004 0 011.926-2.722A3.002 3.002 0 0120.4 13.96M17.4 10.8V9M16.2 9h2.4',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
